import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonAddToCart() {
  function reportAddToCart(
    configId: string | number | undefined,
    productId: string | number,
    itemName: 'Coins Package' | 'Membership',
    price: string | number,
  ) {
    pushAxonEvent('add_to_cart', {
      currency: 'USD',
      value: Number(price),
      items: [buildAxonItem(configId, productId, itemName, price)],
    })
  }

  return { reportAddToCart }
}
